import { render, staticRenderFns } from "./CLegend.vue?vue&type=template&id=3b3ee03e&scoped=true&"
import script from "./CLegend.vue?vue&type=script&lang=js&"
export * from "./CLegend.vue?vue&type=script&lang=js&"
import style0 from "./CLegend.vue?vue&type=style&index=0&id=3b3ee03e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3ee03e",
  null
  
)

export default component.exports